import { createSlice } from "@reduxjs/toolkit";

import { getEvents, addNewEvent, updateEvent, deleteEvent, getCategories, getUpCommingEvent ,resetCalendar,fetchOEMList} from './thunk';

export const initialState = {
  events: [],
  categories: [],
  upcommingevents: [],
  error: {},
  isEventUpdated: false,
  isEventAdded: false,
  isEventDeleted: false
};


const calendarSlice = createSlice({
  name: "calendar",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEvents.fulfilled, (state, action) => {
      state.events = action.payload;
      state.isEventDeleted = false;
    });
    builder.addCase(getEvents.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(addNewEvent.fulfilled, (state, action) => {
      // Don't overwrite events here - they will be refreshed by getEvents call
      // Just mark that an add was successful
      state.isEventAdded = true;
    });
    builder.addCase(addNewEvent.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateEvent.fulfilled, (state, action) => {
      // Don't overwrite events here - they will be refreshed by getEvents call
      // Just mark that an update was successful
      state.isEventUpdated = true;
    });

    builder.addCase(updateEvent.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(deleteEvent.fulfilled, (state, action) => {
      // Remove the deleted event from the current state
      state.events = state.events.filter(
        (event) => event.id !== action.payload
      );
      // Mark that an event was deleted so components can refresh their data
      state.isEventDeleted = true;
    });
    builder.addCase(deleteEvent.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.categories = action.payload;
    });
    builder.addCase(getCategories.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getUpCommingEvent.fulfilled, (state, action) => {
      state.upcommingevents = action.payload;
    });

    builder.addCase(getUpCommingEvent.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
    
    builder.addCase(fetchOEMList.fulfilled, (state, action) => { 
      state.oemList = action.payload;
    });
    builder.addCase(fetchOEMList.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(resetCalendar.fulfilled, (state, action) => {
      var flag = action.payload.flag;
      var value = action.payload.value;
      var flags = {};
      flags[flag] = value;

      // state.flags = action.payload;
    });

    builder.addCase(resetCalendar.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });



  },
});

export default calendarSlice.reducer;